// extracted by mini-css-extract-plugin
export default {"form":"addOfferForm_form__6KabT","label":"addOfferForm_label__ZpYdq"};